import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider, hashKey } from '@tanstack/react-query';
const errorContains = (error, ...substrings) => {
    return Boolean(error instanceof Error && error.message.match(new RegExp(substrings.join('|'))));
};
const STALE_TIME = 30000;
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: STALE_TIME,
            retry: (count, error) => {
                if (errorContains(error, 401, 403, 404, 500)) {
                    return false;
                }
                return process.env.NODE_ENV === 'production' && count < 2;
            },
        },
    },
});
export const withQueryClient = (Component) => {
    return (props) => (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(Component, { ...props }) }));
};
const swrSet = new Set();
export const getSmartQueryData = ({ queryFn, queryKey, swrFn, }) => {
    const data = queryClient.getQueryData(queryKey);
    if (!data || swrSet.has(hashKey(queryKey))) {
        return queryClient.fetchQuery({ queryFn, queryKey }).then((res) => {
            swrSet.delete(hashKey(queryKey));
            return res;
        });
    }
    setTimeout(() => {
        const query = queryClient.getQueryCache().find({ queryKey });
        const isStale = !!query?.state.dataUpdatedAt && Date.now() >= query.state.dataUpdatedAt + STALE_TIME;
        if (isStale && !swrSet.has(hashKey(queryKey))) {
            swrSet.add(hashKey(queryKey));
            swrFn();
        }
    });
    return data;
};
